module.exports = "/images/usa-flag.png?128813d3f93fc6163f396bef8f64b75d";